import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.268 11.813a.7.7 0 1 0-1.367-.301l-1.07 4.856a.7.7 0 1 0 1.367.302l1.07-4.857ZM9.76 13.369a.7.7 0 1 0-.995-.984l-1.2 1.214a.7.7 0 0 0 0 .984l1.2 1.214a.7.7 0 0 0 .996-.984l-.714-.722.714-.722Zm5.475-.984a.7.7 0 0 0-.995.984l.713.722-.713.722a.7.7 0 0 0 .995.984l1.2-1.214a.7.7 0 0 0 0-.984l-1.2-1.214ZM6.713 7.05a.675.675 0 1 1-1.35 0 .675.675 0 0 1 1.35 0Zm1.912 0a.675.675 0 1 1-1.35 0 .675.675 0 0 1 1.35 0Zm1.261.675a.675.675 0 1 0 0-1.35.675.675 0 0 0 0 1.35Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 5.325a1.2 1.2 0 0 1 1.2-1.2h15.6a1.2 1.2 0 0 1 1.2 1.2v13.35a1.2 1.2 0 0 1-1.2 1.2H4.2a1.2 1.2 0 0 1-1.2-1.2V5.325Zm1.4 13.15V9.75h15.2v8.725H4.4ZM19.6 8.35H4.4V5.525h15.2V8.35Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=WebFileIcon24.js.map